import React, { useEffect, useState } from 'react';
import LatestNewsCard from "@/ui/LatestNewsCard";
import LinkedIn from "@/assets/LinkedIn.svg";
import YouTube from "@/assets/YouTube.svg";
import Twitter from "@/assets/Twitter.svg";
import classes from "./styles.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { Title } from "@/ui";

const LatestNews = ({newsTitle}) => {
  const [news, setNews] = useState([]);
  const [selection, setSelection] = useState("LinkedIn");
  const apiKey = "e6e715bdaa21b04373bf17bd8c0d1522";
  const channels = {
    "LinkedIn": "18d8a07c40dcb5b9ec94ac6cc6449281",
    "Twitter": "1ddb502c1983d4d5e83c6e8df69c5950",
    "YouTube": "0735a50b7cd17f8b82eb677d293b7810",
  };

  async function refreshNews() {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${apiKey}`);
    const myRequest = new Request(`https://api.nowsignage.com/v1/channels/${channels[selection]}`, {
      method: "GET",
      headers: myHeaders,
    });
    
    fetch(myRequest)
      .then(async response => {
        if (!response.ok) {
          setNews([]);
        } else {
          const data = await response.json();
          if (data.published_content && data.published_content.entries) {
            const entries = data.published_content.entries;
            setNews(entries.slice(0, 3));
          }
        }
      });
  }

  function handleClick(value) {
    setSelection(value);
  }

  useEffect(() => {
    refreshNews();
  }, [selection])

  return (
    <Container className={`${classes.news}`}>
      <div className={classes.titleCont}>
        <Title tag="div" title={newsTitle} className={`h6 ${classes.title}`} />
        <div className={`${classes.icon} ${selection == "LinkedIn" ? classes.active : ""}`} onClick={() => handleClick("LinkedIn")}>
          <LinkedIn width="16" />
        </div>
        <div className={`${classes.icon} ${selection == "Twitter" ? classes.active : ""}`} onClick={() => handleClick("Twitter")}>
          <Twitter width="18" />  
        </div>
        <div className={`${classes.icon} ${selection == "YouTube" ? classes.active : ""}`} onClick={() => handleClick("YouTube")}>
          <YouTube width="18" />
        </div>
      </div>
      <Row className="mb-md-4">
        {news?.map(({ message, small_image_url, med_image_url, permalink_url, source }, k) => (
          <Col key={k} xs={12} md={4} className="mb-4 mb-md-0">
            <LatestNewsCard
              className="h-100"
              title={message}
              image={small_image_url || med_image_url}
              category={source}
              href={permalink_url}
            />
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default LatestNews